module.exports = __webpack_public_path__ + "static/media/caret-down-select.d0488349.svg";